export class EndPoints {

    static readonly ENDPOINT_WEB_API = 'web-api';

    static readonly ENDPOINT_ALL = 'all';

    // CONFIGURATION
    static readonly ENDPOINT_CONFIGURATION = 'configuration';
    static readonly ENDPOINT_CONFIGURATION_GENERAL = 'general';
    static readonly ENDPOINT_CONFIGURATION_ALIAS = 'alias';
    static readonly ENDPOINT_CONFIGURATION_INDEX_SERVICES = 'index-services';
    static readonly ENDPOINT_CONFIGURATION_INDEX_SERVICES_OVERRIVE = 'override';
    static readonly ENDPOINT_CONFIGURATION_INDEX_SERVICES_CONNECTION = 'connection';
    static readonly ENDPOINT_CONFIGURATION_INDEX_SERVICES_UPDATE = 'update';
    static readonly ENDPOINT_CONFIGURATION_ALIAS_EDIT = 'edit-alias';
    static readonly ENDPOINT_CONFIGURATION_ALERT_RULES = 'rules';
    static readonly ENDPOINT_CONFIGURATION_FAILED_JOBS_NOTIFICATIONS = 'failed-jobs';
    static readonly ENDPOINT_CONFIGURATION_FAILED_JOBS_NOTIFICATIONS_CONFIG = 'config';
    static readonly ENDPOINT_CONFIGURATION_DGES = 'dge';
    static readonly ENDPOINT_CONFIGURATION_SELF_MAINTENANCE = 'self-maintenance';

    // HOME
    static readonly ENDPOINT_HOME = 'home';
    static readonly ENDPOINT_HOME_HOUR = 'hours';
    static readonly ENDPOINT_HOME_REFRESH_HOUR = 'refresh-hours';
    static readonly ENDPOINT_HOME_CHARTS = 'charts';
    static readonly ENDPOINT_HOME_CARD = 'card';

    // AIM
    static readonly ENDPOINT_AIM = 'web/components-api/access-control/aim';
    static readonly ENDPOINT_AIM_CONFIG = 'config';
    static readonly ENDPOINT_AIM_CONNECTION = 'connection';

    // STATISTICS
    static readonly ENDPOINT_STATISTICS = 'statistics';
    static readonly ENDPOINT_STATISTICS_JOB = 'jobs';
    static readonly ENDPOINT_STATISTICS_HAS_RELAUNCHED_JOBS = 'has-relaunched-jobs';
    static readonly ENDPOINT_STATISTICS_RELAUNCHED_JOBS = 'relaunched-jobs';
    static readonly ENDPOINT_STATISTICS_CONFIGURATION_JOB = 'configuration-job';
    static readonly ENDPOINT_STATISTICS_RELAUNCH_JOB = 'relaunch-job';
    static readonly ENDPOINT_STATISTICS_LOG = 'logs';
    static readonly ENDPOINT_STATISTICS_CARDS = 'cards';
    static readonly ENDPOINT_STATISTICS_LAST_JOB_ID = 'getLastJobId';

    // DGE
    static readonly ENDPOINT_DGE = 'dge';
    static readonly ENDPOINT_DGE_WARNING_UNLINK = 'unlink-not-connected';
    static readonly ENDPOINT_DGE_UNLINK = 'unlink';

    // MONITORING
    static readonly ENDPOINT_MONITORING = 'monitoring';
    static readonly ENDPOINT_MONITORING_ALERTS = 'alerts';
    static readonly ENDPOINT_MONITORING_RULES_ASSIGNMENT = 'rules-assignment';
    static readonly ENDPOINT_MONITORING_REFERENCE_VALUES = 'reference-values';
}